import { Box, Grid } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";

import AError from "../components/a-error";

const ErrorPage = ({ errorMessage }: { errorMessage: string | undefined }) => {
  const { t } = useTranslation();

  return (
    <Grid container alignItems="center" justifyContent="center" sx={{ height: "100%" }}>
      <Grid item xs={12}>
        <Box display="flex" justifyContent="space-around" width="100%">
          <AError errorMessage={errorMessage ?? t("somethingWentWrong")} />
        </Box>
      </Grid>
    </Grid>
  );
};

export default ErrorPage;
